import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import aboutUs from '@/components/aboutUs'
import products from '@/components/products'
import partner from '@/components/partner'
import contact from '@/components/contact'
import jobs from '@/components/jobs'
import news from '@/components/news'
import download from '@/components/download'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/products',
      name: 'products',
      component: products
    },
    {
      path: '/partner',
      name: 'partner',
      component: partner
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/jobs',
      name: 'jobs',
      component: jobs
    },
    {
      path: '/download',
      name: 'download',
      component: download
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js